@import '../../shared.scss';

.edu-heading {
  margin-top: 3.2rem;
}

.modal__contents-inner > .edu-heading:first-child {
  margin-top: 0;
}
